import React, { useContext, useState } from "react";
import { Card, Form, Select, Space, theme } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import type { LocationType, DepartmentType } from "./types";
import { DepartmentOperation } from "../../../serviceoperation/DepartmentOperation";
import { CompanyContext } from "../../../contexts/company-context";
import { EmployeeDetails } from "../../../serviceoperation/entity/EmployeeOperationEntity";

interface Props {
  employee: EmployeeDetails | null;
  form: any; // FormInstance
  locations: LocationType[];
  isEditing: boolean;
}

const WorkInfoForm: React.FC<Props> = ({
  employee,
  form,
  locations,
  isEditing,
}) => {
  const { token } = theme.useToken();
  const [showDepart, setShowDepart] = useState(false);
  const { selectedCompany } = useContext(CompanyContext);
  const [departments, setDepartments] = useState<DepartmentType[]>([
    {
      key: employee?.organization?.departmentId || "",
      name: employee?.organization?.departmentName || "",
    },
  ]);

  const handleLocationChange = (changedValues: React.Key) => {
    const departmentOps = new DepartmentOperation();
    departmentOps
      .getDepartmentByAsync(
        selectedCompany?.corporationId as number,
        changedValues as number
      )
      .then((value) => {
        setDepartments(
          value.data.map((s) => ({
            key: s.departmentId,
            name: s.name,
          }))
        );
      });
    // if changedValues is not null or undefined
    // Then Enable the Department fields.
    setShowDepart(true);
  };

  const getPotentialManagers = () => {
    return [
      {
        value: employee?.managerId,
        label: employee?.managerName,
        name: employee?.managerName,
      },
    ];
  };

  return (
    <Card
      title={
        <span>
          <TeamOutlined style={{ color: token.colorPrimary }} />{" "}
          <span style={{ marginLeft: 8 }}>Work Information</span>
        </span>
      }
      size="small"
      style={{ marginBottom: 16 }}
    >
      <Form form={form} layout="vertical" disabled={!isEditing}>
        <Space direction="vertical" style={{ width: "100%" }} size="middle">
          <Form.Item
            name="locationId"
            label="Branch"
            rules={[{ required: true, message: "Please select a location" }]}
          >
            <Select
              placeholder="Select branch"
              onSelect={handleLocationChange}
              style={{ borderRadius: 6 }}
              options={locations.map((loc) => ({
                label: (
                  <Space>
                    <div
                      style={{
                        width: 12,
                        height: 12,
                        borderRadius: 2,
                        backgroundColor: loc.color,
                        display: "inline-block",
                      }}
                    />
                    {loc.name}
                  </Space>
                ),
                value: loc.key,
              }))}
            />
          </Form.Item>

          <Form.Item
            name="departmentId"
            label="Department"
            rules={[{ required: true, message: "Please select a department" }]}
          >
            <Select
              placeholder="Select department"
              disabled={!showDepart}
              options={departments.map((d) => ({
                label: d.name,
                value: d.key,
              }))}
              showSearch
            />
          </Form.Item>

          <Form.Item
            name="managerId"
            label="Manager"
            help={
              isEditing
                ? "Select the direct manager for this employee"
                : undefined
            }
          >
            <Select
              placeholder="Select manager"
              style={{ borderRadius: 6 }}
              allowClear
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={getPotentialManagers()}
            />
          </Form.Item>
        </Space>
      </Form>
    </Card>
  );
};

export default WorkInfoForm;
